
import React from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Mixpanel } from '../../redux/Mixpanel';
import _ from 'lodash';
import {
    Row,
    Col,
} from 'reactstrap';
import {
    IonButton, IonSelect, IonSelectOption,
    IonContent, IonHeader, IonIcon, IonPage,
    IonTitle, IonToolbar,
    IonList, IonInfiniteScroll, IonInfiniteScrollContent,
    IonModal, IonButtons,
    IonFab, IonFabButton, IonFabList, IonMenuButton,
    IonLoading, IonItem, IonCheckbox, IonChip, IonLabel
} from '@ionic/react';
import {
    add,
    arrowBack,
    flashSharp,
    optionsOutline
} from 'ionicons/icons';
import dayjs from 'dayjs';

import {
    showLoading,
    fetchOptions,
    fetchUnitUtilities,
    deleteUnitUtility,
    fetchInvoices,
    fetchPropertyUnitUtilities,
    addUtilitiesBulk,
    bulkCreateUtilityInvoices,
    sendInvoice,
    showCustomMessage,
    fetchCurrency
} from '../../redux/actions';

import {
    UtilitiesForm, InvoiceForm, PropertyForm,
    ResetUtilitiesForm
} from '../Forms';
import { fetchPropertiesUnitsTenants } from '../../redux/middleware';
import store from '../../redux/store';
import { formatDate } from '../../utils';
import { colorTheme } from '../../utils/constants';
import IonCustomPropertySelect from '../../components/IonCustomPropertySelect';
import UtilityListItem from './UtilityListItem';
import PropertyUtilities from './PropertyUtilities';
import * as PermChecker from '../../utils/PermUtils';
import NotificationPermissionModal from '../../components/NotificationPermissionModal';
import { openNotificationPromptIfEligible, handleNotificationPromptAllow, handleNotificationPromptDeny } from '../../utils/notificationPrompt';

const mapStateToProps = state => {
    return {
        properties: state.properties,
        units: state.units,
        unitUtilities: state.unitUtilities,
        currency: state.currency,
        options: state.options
    };
}


const mapDispatchToProps = {
    showLoading,
    fetchOptions,
    fetchUnitUtilities,
    deleteUnitUtility,
    fetchInvoices,
    fetchPropertyUnitUtilities,
    addUtilitiesBulk,
    bulkCreateUtilityInvoices,
    sendInvoice,
    showCustomMessage,
    fetchCurrency
};

const HOME_PAGE = "unitUtilities";
const UTILITIES_FORM_PAGE = "utilityForm";
const INVOICES_FORM_PAGE = "invoiceForm";
const UNIT_UTILITIES_PAGE = "bulkUploadTable";
const PROPERTIES_FORM_PAGE = "propertiesForm";
const RESET_UTILITIES_FORM = "resetUtilitiesForm";
const FILTERS_PAGE = "filters";


class Utilities extends React.Component{
    constructor(props){
        super(props);

        this.changeTabfromChildComponent = this.changeTabfromChildComponent.bind(this)
        this.updateUnitUtilityToEditFromChild = this.updateUnitUtilityToEditFromChild.bind(this)
        this.moveToOtherTabFromChild = this.moveToOtherTabFromChild.bind(this);

        const routerState = (this.props.location && this.props.location.state) ? this.props.location.state : {};

        this.state = {
            tab: routerState.openBulkUtilities ? UNIT_UTILITIES_PAGE : HOME_PAGE,
            unitUtilityIdToEdit: null,
            propertyId: "",
            properties: [],
            unitId: "",
            filters:{
                utilityItem: [
                    {id: 1, value: "water", isChecked: true},
                    {id: 2, value: "electricity", isChecked: true}
                ],
            },
            selected:[],
            utilities: [],
            offset: "",
            startDate: null,
            endDate: null,
            focusedDateInput: null,
            utilityItem: "",
            invoiceId: "",
            invoice: null,
            utilItem: "",
            utilsPropertyId: "",
            utilsUnitId: "",
            previousTab: HOME_PAGE,
            currentPage: 0,
            readonly: false,
            errors: [],
            bulkUtilitiesTabPropertyId:"",
            bulkUtilitiesTabUtilityItem:"",
            fromViewInvoice: false,
            userAllPerms: {},
            showNotificationPrompt: false,
            notificationContext: routerState.notificationContext || null
        }
    }

    async fetchInitialData(){
        if(_.isEmpty(this.props.properties)){
            this.props.showLoading(true);
            await store.dispatch(fetchPropertiesUnitsTenants);
        }
        await Promise.all([
            (
                async () => {
                    if(_.isEmpty(this.props.properties)){
                        this.props.showLoading(true);
                        await store.dispatch(fetchPropertiesUnitsTenants);
                    }
                }
            )(),
            (
                async () => {
                    if(_.isEmpty(this.props.options)){
                        this.props.showLoading(true);
                        await this.props.fetchOptions();
                    }
                }
            )(),
            (
                async () => {
                    if(_.isEmpty(this.props.currency)){
                        this.props.showLoading(true);
                        await this.props.fetchCurrency();
                    }
                }
            )(),
            (
                async () => {
                    if(_.isEmpty(this.props.unitUtilities)){
                        this.props.showLoading(true);
                        const params = this.getQueryParams();
                        let payloadResult = await this.props.fetchUnitUtilities(params);
                        if(payloadResult && payloadResult.offset){

                            let offset = payloadResult.offset;
                            this.setState({
                                offset
                            })
                        }
                    }
                }
            )()

        ]);
    }

    getQueryParams(offset="", appendData=false){
        let unitIds = [];
        let propertyIds = [];
        // filtering by property or unit if any is selected
        if (this.state.propertyId){
            propertyIds = [this.state.propertyId];
            if(this.state.unitId){
                propertyIds = [];
                unitIds = [this.state.unitId];
            }
        }
        // collecting data needed for the fetching of filtered data
        let params = {
            propertyIds: propertyIds,
            unitIds:unitIds,
            startDate:this.state.startDate,
            endDate: this.state.endDate,
            utilityItems:this.getSelectedSUtilityItemsFilters(),  // get the selected unit utilities
            offset,
            appendData  // this is used in the reducer to determine whether data is replaced or appended. false means we replace data fully
        }
        return params;
    }

    async componentDidMount(){
        this.setState({showLoading: true});
        await this.fetchInitialData();
        const utilities = this.formatUnitUtilities(Object.values(this.props.unitUtilities));
        let propertyId = "";
        if (Object.values(this.props.properties).length === 1){
            propertyId = Object.values(this.props.properties)[0].propertyId;
        }
        const hasAllInvoicePerm = PermChecker.checkUserHasPermission(PermChecker.INVOICE_MODEL, PermChecker.ALL_PERM, this.props.options?.userPermissions);
        const hasAllUtilityPerm = PermChecker.checkUserHasPermission(PermChecker.UTILITY_MODEL, PermChecker.ALL_PERM, this.props.options?.userPermissions);
        this.setState({
            properties: Object.values(this.props.properties),
            propertyId,
            utilities,
            userAllPerms: {
                invoice: hasAllInvoicePerm,
                utility: hasAllUtilityPerm
            }
         }, () => {
            this.applyUrlParams();
         });
         this.setState({showLoading: false});
    }

    formatUnitUtilities(utilities){
        return utilities.map(
            utility => {
                let propertyName = "";
                let unitName = "";
                if(this.props.properties && this.props.units[utility.unit]){
                    propertyName = this.props.properties[this.props.units[utility.unit].propertyId].propertyName;
                    unitName = this.props.units[utility.unit].unitName;
                }
                return ({
                    propertyName,
                    unitName,
                    formattedDate: formatDate(utility.date),
                    utilityIdInvoiceColumn: utility.utilityId,
                    ...utility
                })
            }
        );
    }


    async componentDidUpdate(prevProps, prevState){
        let props = this.props;
        if (JSON.stringify(this.props.unitUtilities) !== JSON.stringify(prevProps.unitUtilities)){
            this.setState((prevState) => {
                let utilities = this.formatUnitUtilities(Object.values(this.props.unitUtilities));
                return { utilities };
            });
        }
        // handling changes in any filter
        const filtersChanged = (
            this.state.filters !== prevState.filters ||
            this.state.startDate !== prevState.startDate ||
            this.state.endDate !== prevState.endDate ||
            this.state.propertyId !== prevState.propertyId ||
            this.state.unitId !== prevState.unitId ||
            JSON.stringify(this.props.unitUtilities) !== JSON.stringify(prevProps.unitUtilities)
           );
        if (filtersChanged){
            this.props.showLoading(true);
            await this.fetchUtilities();
            this.props.showLoading(false);
        }
        if (filtersChanged){
            this.updateUrlParams({
                propertyId: this.state.propertyId,
                unitId: this.state.unitId,
                startDate: this.state.startDate ? this.state.startDate.format('YYYY-MM-DD') : '',
                endDate: this.state.endDate ? this.state.endDate.format('YYYY-MM-DD') : '',
                utilityItems: this.getSelectedSUtilityItemsFilters()
            });
        }
        const openBulkUtilities = this.props.location.state?.openBulkUtilities === true;
        const openBulkUtilitiesAt = this.props.location.state?.openBulkUtilitiesAt || null;
        const prevOpenBulkUtilitiesAt = prevProps.location.state?.openBulkUtilitiesAt || null;
        if (openBulkUtilities && (this.state.tab !== UNIT_UTILITIES_PAGE || openBulkUtilitiesAt !== prevOpenBulkUtilitiesAt)) {
            this.setState({
                tab: UNIT_UTILITIES_PAGE,
                previousTab: this.state.tab
            });
        }
        if (openBulkUtilities && _.isEmpty(this.props.properties)) {
            this.props.showLoading(true);
            await store.dispatch(fetchPropertiesUnitsTenants);
            this.setState({ properties: Object.values(this.props.properties) });
            this.props.showLoading(false);
        }
        const notificationContext = this.props.location.state?.notificationContext || null;
        const prevNotificationContext = prevProps.location.state?.notificationContext || null;
        if (notificationContext !== prevNotificationContext) {
            this.setState({ notificationContext });
        }

    }

    async fetchUtilities(offset="", appendData=false){
        const params = this.getQueryParams(offset, appendData);
        let payloadResult = await this.props.fetchUnitUtilities(params); //fetch data
        let newOffset = this.state.offset;
        if(payloadResult && payloadResult.offset){
            offset = payloadResult.offset; //getting the new offset which will be used in the next request if any
        }

        this.setState((state) => {
            let utilities = this.formatUnitUtilities(Object.values(this.props.unitUtilities));
            return {
                utilities,
                offset: newOffset
            }
        });
    }

    getSelectedSUtilityItemsFilters(){
        let allUtilityItems = this.state.filters.utilityItem;
        let selectedUtilityItems = [];
        allUtilityItems.map((item) => {
            if(item.isChecked){
                selectedUtilityItems.push(item.value)
            }
        })
        return selectedUtilityItems
    }

    getUrlParams() {
        const searchParams = new URLSearchParams(this.props.location.search || "");
        return {
            propertyId: searchParams.get('propertyId') || '',
            unitId: searchParams.get('unitId') || '',
            startDate: searchParams.get('startDate') || '',
            endDate: searchParams.get('endDate') || '',
            utilityItems: searchParams.get('utilityItems') ? searchParams.get('utilityItems').split(',') : []
        };
    }

    updateUrlParams(params) {
        const searchParams = new URLSearchParams(this.props.location.search || "");
        Object.entries(params).forEach(([key, value]) => {
            if (value === null || value === undefined || value === '' || (Array.isArray(value) && value.length === 0)) {
                searchParams.delete(key);
            } else {
                const formatted = Array.isArray(value) ? value.join(',') : String(value);
                searchParams.set(key, formatted);
            }
        });
        const queryString = searchParams.toString();
        this.props.history.replace({ search: queryString ? `?${queryString}` : '' });
    }

    applyUrlParams() {
        const params = this.getUrlParams();
        const hasUtilityItems = params.utilityItems.length > 0;
        const nextItems = this.state.filters.utilityItem.map((item) => ({
            ...item,
            isChecked: hasUtilityItems ? params.utilityItems.includes(item.value) : item.isChecked
        }));
        this.setState({
            propertyId: params.propertyId || this.state.propertyId,
            unitId: params.unitId || this.state.unitId,
            startDate: params.startDate ? dayjs(params.startDate) : this.state.startDate,
            endDate: params.endDate ? dayjs(params.endDate) : this.state.endDate,
            filters: {
                ...this.state.filters,
                utilityItem: nextItems
            }
        });
    }

    getDefaultPropertyId(){
        const properties = Object.values(this.props.properties || {});
        return properties.length === 1 ? properties[0].propertyId : "";
    }

    handleClearFilters(){
        this.setState((prevState) => ({
            startDate: null,
            endDate: null,
            propertyId: this.getDefaultPropertyId(),
            unitId: "",
            filters: {
                ...prevState.filters,
                utilityItem: prevState.filters.utilityItem.map((item) => ({ ...item, isChecked: true }))
            }
        }));
    }

    renderActiveFilters(){
        const hasPropertyFilter = !!this.state.propertyId;
        const hasUnitFilter = !!this.state.unitId;
        const hasDateFilter = !!(this.state.startDate || this.state.endDate);
        const selectedUtilityItems = this.getSelectedSUtilityItemsFilters();
        const hasUtilityFilter = selectedUtilityItems.length !== this.state.filters.utilityItem.length;
        const hasFilters = hasPropertyFilter || hasUnitFilter || hasDateFilter || hasUtilityFilter;

        if (!hasFilters) return null;

        return (
            <div className="ion-padding-start ion-padding-end" style={{ marginBottom: '6px' }}>
                <div style={{ display: 'flex', gap: '8px', overflowX: 'auto' }}>
                    {hasPropertyFilter && (
                        <IonChip>
                            <IonLabel>Property</IonLabel>
                        </IonChip>
                    )}
                    {hasUnitFilter && (
                        <IonChip>
                            <IonLabel>Unit</IonLabel>
                        </IonChip>
                    )}
                    {hasDateFilter && (
                        <IonChip>
                            <IonLabel>Date Range</IonLabel>
                        </IonChip>
                    )}
                    {hasUtilityFilter && (
                        <IonChip>
                            <IonLabel>Utility Item</IonLabel>
                        </IonChip>
                    )}
                    <IonChip onClick={this.handleClearFilters.bind(this)}>
                        <IonLabel>Clear All</IonLabel>
                    </IonChip>
                </div>
            </div>
        );
    }

    addZeroPrefixToSingleDigits(numString){

        if (numString.length == 1){
            numString = "0"+ numString
        }

        return numString
    }


    handleCloseUtilityModal(){
        const { tab, unitUtilityIdToEdit} = this.state
        this.setState({
            tab: tab == INVOICES_FORM_PAGE ? tab : HOME_PAGE,
            unitUtilityIdToEdit: tab == INVOICES_FORM_PAGE ? unitUtilityIdToEdit : null,
            utilityAction: ""
        })
    }

    handleFilterModalDismiss(){
        this.setState({ tab: HOME_PAGE });
    }

    renderFilters(){
        return (
            <IonModal isOpen={this.state.tab === FILTERS_PAGE} onDidDismiss={this.handleFilterModalDismiss.bind(this)}>
                <IonHeader>
                    <IonToolbar>
                        <IonTitle>Filters</IonTitle>
                        <IonButtons slot="end">
                            <IonButton onClick={this.handleFilterModalDismiss.bind(this)}>Close</IonButton>
                        </IonButtons>
                    </IonToolbar>
                </IonHeader>
                <IonContent className="ion-padding">
                    <div style={{ width: '100%' }}>
                        <IonList style={{ width: '100%', maxWidth: '500px', margin: '0 auto' }}>
                            <IonItem style={{ marginTop: '6px', marginBottom: '6px' }}>
                                <IonSelect
                                    label="Property"
                                    labelPlacement="stacked"
                                    interface="popover"
                                    value={this.state.propertyId}
                                    onIonChange={this.handleSelectProperty.bind(this)}
                                >
                                    <IonCustomPropertySelect propertiesArray={this.state.properties}/>
                                </IonSelect>
                            </IonItem>
                            <IonItem style={{ marginTop: '6px', marginBottom: '6px' }}>
                                <IonSelect
                                    label="Unit"
                                    labelPlacement="stacked"
                                    interface="popover"
                                    value={this.state.unitId}
                                    onIonChange={this.handleSelectUnit.bind(this)}
                                >
                                    <IonSelectOption key={""} value="">All Units</IonSelectOption>
                                    {this.state.propertyId == ""?
                                        <IonSelectOption>Please First Select a Property ...</IonSelectOption> :
                                        _.map(Object.keys(this.props.properties[this.state.propertyId]["units"]), (unit) => (
                                            <IonSelectOption key={unit} value={unit}>
                                                {this.props.units[unit].unitName}
                                            </IonSelectOption>
                                    ))}
                                </IonSelect>
                            </IonItem>
                            <IonItem lines="none" style={{ marginTop: '6px', marginBottom: '6px' }}>
                                <div style={{ width: '100%' }}>
                                    <div style={{ fontWeight: 700, fontSize: '1rem' }}>Date Range</div>
                                    <div style={{ display: 'flex', gap: '12px', marginTop: '8px' }}>
                                        <input
                                            type="date"
                                            id="utilitiesStartDate"
                                            name="utilitiesStartDate"
                                            value={this.state.startDate ? this.state.startDate.format('YYYY-MM-DD') : ''}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                this.setState({ startDate: value ? dayjs(value) : null });
                                            }}
                                            style={{ width: '100%', textAlign: 'center', padding: '8px', border: '1px solid gray' }}
                                        />
                                        <input
                                            type="date"
                                            id="utilitiesEndDate"
                                            name="utilitiesEndDate"
                                            value={this.state.endDate ? this.state.endDate.format('YYYY-MM-DD') : ''}
                                            min={this.state.startDate ? this.state.startDate.format('YYYY-MM-DD') : undefined}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                this.setState({ endDate: value ? dayjs(value) : null });
                                            }}
                                            style={{ width: '100%', textAlign: 'center', padding: '8px', border: '1px solid gray' }}
                                        />
                                    </div>
                                </div>
                            </IonItem>

                            <IonItem lines="none" style={{ marginTop: '6px', marginBottom: '6px' }}>
                                <div style={{ width: '100%' }}>
                                    <div style={{ fontWeight: 700, fontSize: '1rem' }}>Utility Item</div>
                                    {this.state.filters.utilityItem.map((item) => (
                                        <IonItem key={item.id + item.isChecked.toString()}>
                                            <IonCheckbox
                                                labelPlacement="end"
                                                checked={item.isChecked}
                                                onIonChange={(e) => this.handleCheckChieldElement(item.value, e.detail.checked)}
                                            >
                                                {item.value}
                                            </IonCheckbox>
                                        </IonItem>
                                    ))}
                                </div>
                            </IonItem>
                        </IonList>
                    </div>
                </IonContent>
            </IonModal>
        )
    }

    handleCloseInvoiceModal(){
        this.setState({
            tab: this.state.fromViewInvoice ? HOME_PAGE : UTILITIES_FORM_PAGE,
        })
    }

    handleClosePropertyModal(){
        this.setState({
            tab: HOME_PAGE,
        })
    }

    handleCloseResetUtilitiesForm(){
        this.setState({
            tab: HOME_PAGE,
        })
        const params = this.getQueryParams();
        this.props.fetchUnitUtilities(params);
    }

    renderUtilitiesForm(){
        return (
            <IonModal isOpen={this.state.tab === UTILITIES_FORM_PAGE} onDidDismiss={this.handleCloseUtilityModal.bind(this)}>
                <IonHeader>
                    <IonToolbar>
                        <IonTitle>Utility Form</IonTitle>
                        <IonButtons slot="end">
                        <IonButton onClick={this.handleCloseUtilityModal.bind(this)}>
                            Close
                        </IonButton>
                        </IonButtons>
                    </IonToolbar>
                </IonHeader>
                <IonContent className="ion-padding">
                    <UtilitiesForm
                        utility={this.props.unitUtilities[this.state.unitUtilityIdToEdit]}
                        changeTab = {this.changeTabfromChildComponent}
                        updateUnitUtilityObj = {this.updateUnitUtilityToEditFromChild}
                        action={this.state.utilityAction}
                    />
            </IonContent>
            </IonModal>);
    }

    //update the utilityToEdit object value from child component.
    updateUnitUtilityToEditFromChild(utilityToEdit){
        this.setState({
            unitUtilityToEdit: utilityToEdit
          })

    }

    async handleBackButton(event){
        event.preventDefault();
        this.setState({
            unitUtilityToEdit: this.state.tab == UTILITIES_FORM_PAGE ? null : this.state.unitUtilityToEdit,
            tab: this.state.previousTab,
            previousTab: this.state.tab == HOME_PAGE ? this.state.tab : HOME_PAGE,
            utilityAction: ""
        });
        const params = this.getQueryParams();
        this.props.showLoading(true);
        this.props.fetchUnitUtilities(params);
    }

    handleSelectProperty(event){
        let value = event.target.value;

        if (event.target.name == "propertyId"){
            this.setState((prevState) => {
                let { utilsPropertyId, utilsUnitId } = prevState;
                if (utilsPropertyId != value){
                    utilsPropertyId = value;
                    utilsUnitId = "";
                }
                return {
                    utilsPropertyId, utilsUnitId
                };
            });
        }else{
            this.setState((prevState) => {
                let { propertyId, unitId } = prevState;
                if (propertyId != value){
                    propertyId = value;
                    unitId = "";
                }
                return {
                    propertyId, unitId
                };
            });
        }

    }

    handleSelectUtilityItem(event){
        let value = event.target.value;

        this.setState((prevState) => {
            let { utilItem } = prevState;
            if (utilItem != value){
                utilItem = value;
            }
            return {
                utilItem
            };
        });
    }

    handleSelectUnit(event){
        event.preventDefault();
        let value = event.target.value;
        let name = event.target.name;
        if (name == "unitId"){
            this.setState((prevState) => {
                let { utilsUnitId } = prevState;
                if (utilsUnitId != value){
                    utilsUnitId = value;
                }
                return {
                    utilsUnitId
                }
            });

        }else{
            this.setState((prevState) => {
                let { unitId } = prevState;
                if (unitId != value){
                    unitId = value;
                }
                return {
                    unitId
                }
            });
        }
    }

    handleSelectEditUnitUtility(utility, event){
        event.preventDefault();
        this.setState({
            unitUtilityToEdit: utility,
            tab: UTILITIES_FORM_PAGE,
            previousTab: this.state.tab // if this.state.tab != HOMEPAGE else HOMEPAGE
        });
    }

    async handleUnitUtilityAction(key, utilityId){
        if (key === 'edit'){
            this.setState({
                unitUtilityIdToEdit: utilityId,
                tab: UTILITIES_FORM_PAGE,
                previousTab: this.state.tab
            });

        } else if(key === 'delete'){
            const confirmed = window.confirm("Are you sure you want to delete this utility?");
            if (confirmed) {
                this.props.showLoading(true);
                await this.props.deleteUnitUtility(utilityId);
            }
            await this.showNotificationPromptIfEligible();
        } else if(key === 'create-invoice'){
            this.setState({
                unitUtilityIdToEdit: utilityId,
                tab: UTILITIES_FORM_PAGE,
                utilityAction: "generateInvoice"
            });
            await this.showNotificationPromptIfEligible();
        } else if(key === 'view-invoice'){
            this.setState({
                tab: INVOICES_FORM_PAGE,
                invoiceId: utilityId,
                fromViewInvoice: true
            });
            await this.showNotificationPromptIfEligible();
        }
    }


    handleCheckChieldElement = async (value, checked) => {
        await this.setState((prevState) => {
            let utilityItem = prevState.filters.utilityItem.map(i => {
                if (i.value === value){
                    i.isChecked = checked
                }
                return {...i};
            });
            return {
                filters: {
                    ...prevState.filters,
                    utilityItem
                }
            };
        });
    }

    handleSelect(row, isSelected) {
        if (isSelected) {
            this.setState({ selected: [...this.state.selected, row.utilityId] });
        } else {
            this.setState({
                selected: this.state.selected.filter(itemId => itemId !== row.utilityId)
            });
        }
    }

    handleSelectAll(isSelected, rows){
        if (isSelected) {
            this.setState({ selected: _.map(rows, 'utilityId') })
        } else {
            this.setState({ selected: [] });
        }
    }

    handleSelectInvoice(invoiceId) {
        this.setState({
            tab: INVOICES_FORM_PAGE,
            invoiceId
        });
    }

    renderUtilitiesTable(){
        return (
            <React.Fragment>
                <IonHeader className="ion-no-border">
                <Row className='mx-1 my-2 d-flex justify-content-end'>
                    <Col className='mx-0 my-2 pt-1 rounded d-flex justify-content-end' xs={12} md={12} style={{width:'3.4375em', backgroundColor: colorTheme["primary"]["25"], color: colorTheme["primary"]["800"]}}>
                        <IonIcon onClick={ () => { this.setState({tab: FILTERS_PAGE}) }}
                            size="large" aria-hidden="true" id='utilities-filter-icon'
                        icon={optionsOutline}
                        />
                    </Col>
                    </Row>
                    {this.renderActiveFilters()}

                </IonHeader>

                <div>
                    <IonList style={{margin: 0, padding: 0}}>
                        {this.state.utilities.map((utility) => {
                            return (<UtilityListItem
                                key={utility.utilityId}
                                userAllPerms={this.state.userAllPerms}
                                utilityId={utility.utilityId}
                                utilityItem={utility.item}
                                unitName={utility.unitName}
                                propertyName={utility.propertyName}
                                utility={this.props.unitUtilities[utility.utilityId]}
                                showDetails={false}
                                invoiceId={utility.invoiceId}
                                handleUnitUtilityAction={this.handleUnitUtilityAction.bind(this)}
                            />
                            )
                        })}
                    </IonList>

                    <IonInfiniteScroll
                        threshold='100px'
                        onIonInfinite={async (ev) => {
                            await this.fetchUtilities(this.state.offset, true);
                            ev.target.complete();
                        }}
                    >
                        <IonInfiniteScrollContent loadingText="Please wait..." loadingSpinner="bubbles"></IonInfiniteScrollContent>
                    </IonInfiniteScroll>
                </div>

            </React.Fragment>
                );

    }

    onClickBulkUploadUtilities(event) {
        event.preventDefault();
        this.setState({ tab: UNIT_UTILITIES_PAGE,
            previousTab: this.state.tab
        });
        Mixpanel.track("Utilities tab original: bulk upload utilities");
    }

    async handleCreateUtilityInvoices(){
        if(this.state.selected.length == 0){
            this.props.showCustomMessage("","Please select a Utility.");
        }else{
            if (this.state.notificationContext?.notification_type === 'utility_bill_generation_reminder') {
                Mixpanel.track("reminder: utility_generation primary_action", {
                    notification_type: this.state.notificationContext.notification_type,
                    action: "create_utility_invoices",
                    actionId: this.state.notificationContext.actionId || "unknown",
                    source: this.state.notificationContext.source || "unknown"
                });
                this.setState({ notificationContext: null });
            }
            const action = await this.props.bulkCreateUtilityInvoices(this.state.selected);
            if(!action.errors){
                let message = ""
                const errors = action.payload.errors;
                if(errors.length > 0){
                    message = "Errors: \n"
                    for(let i=0; i < errors.length; i++){
                        message += "- " + errors[i] + "\n"
                    }
                }
                this.props.showCustomMessage(action.payload.feedbackSummary, message);
            }
            Mixpanel.track("Utilities tab original: create invoice");
        };


    }

    async handleSendInvoiceSMS(){
        if(this.state.selected.length == 0){
            this.props.showCustomMessage("","Please select a Utility.");
        }else{
            let invoiceIds = [];
            for (let utilityId of this.state.selected){
                if(this.props.unitUtilities[utilityId].invoiceId){
                    invoiceIds.push(this.props.unitUtilities[utilityId].invoiceId);
                }
            }
            await this.props.sendInvoice({invoiceIds});
            Mixpanel.track("Utilities tab original: send invoice SMS");
            await this.showNotificationPromptIfEligible();
        }
    }

    async showNotificationPromptIfEligible() {
        await openNotificationPromptIfEligible((open) => this.setState({ showNotificationPrompt: open }));
    }

    renderHomePage(){
        return (
            <div>
                {this.renderUtilitiesTable()}
                <NotificationPermissionModal
                    isOpen={this.state.showNotificationPrompt}
                    header="Enable notifications?"
                    message="Enable reminders so you never miss creating utility invoices on time."
                    onCancel={async () => {
                        await handleNotificationPromptDeny((open) => this.setState({ showNotificationPrompt: open }), 'utilities');
                    }}
                    onDeny={async () => {
                        await handleNotificationPromptDeny((open) => this.setState({ showNotificationPrompt: open }), 'utilities');
                    }}
                    onAllow={async () => {
                        await handleNotificationPromptAllow((open) => this.setState({ showNotificationPrompt: open }), 'utilities');
                    }}
                />
            </div>
        )
    }

    renderUtilities(propertyId, utilityItem){
        return (
            <IonModal isOpen={this.state.tab === UNIT_UTILITIES_PAGE} onDidDismiss={this.handleClosePropertyModal.bind(this)}>
                <IonHeader>
                    <IonToolbar>
                        <IonTitle>Bulk Add Utilities</IonTitle>
                        <IonButtons slot="end">
                            <IonButton
                                onClick={this.handleClosePropertyModal.bind(this)}
                            >
                                Close
                            </IonButton>
                        </IonButtons>
                    </IonToolbar>
                </IonHeader>
                <IonContent className="ion-padding">
                    <PropertyUtilities
                        changeTab = {this.moveToOtherTabFromChild}
                        from={HOME_PAGE}
                        propertyId = {propertyId}
                        utilityItem = {utilityItem}/>
                </IonContent>
            </IonModal>
        )
    }

    moveToOtherTabFromChild(newTab, bulkUtilitiesTabPropertyId="", bulkUtilitiesTabUtilityItem=""){
        this.setState({
            bulkUtilitiesTabPropertyId: bulkUtilitiesTabPropertyId ? bulkUtilitiesTabPropertyId : "",
            bulkUtilitiesTabUtilityItem: bulkUtilitiesTabUtilityItem ? bulkUtilitiesTabUtilityItem : "",
            tab: newTab,
            previousTab: this.state.tab
          })

    }

    renderInvoiceForm(){
        return (
            <IonModal isOpen={this.state.tab === INVOICES_FORM_PAGE} onDidDismiss={this.handleCloseInvoiceModal.bind(this)}>
                <IonHeader>
                    <IonToolbar>
                        <IonTitle>Invoice Form</IonTitle>
                        <IonButtons slot="end">
                            <IonButton
                                onClick={this.handleCloseInvoiceModal.bind(this)}
                            >
                                Close
                            </IonButton>
                        </IonButtons>
                    </IonToolbar>
                </IonHeader>
                <IonContent className="ion-padding">
                    <InvoiceForm invoiceId={this.state.invoiceId}
                        invoice={this.state.invoice}
                        fromUtilities={true}
                        changeTab={this.changeTabfromChildComponent}
                    />
                </IonContent>
            </IonModal>
        );
    }

    changeTabfromChildComponent( invoiceId="",invoice=null, propertyId = "" ){

        this.setState({
            tab: INVOICES_FORM_PAGE,
            invoiceId: invoiceId,
            invoice: invoice,
            previousTab: this.state.utilityAction == "generateInvoice"? HOME_PAGE : this.state.tab,
            utilityAction: "",
            fromViewInvoice: false,
            bulkUtilitiesTabPropertyId: propertyId
          })

    }

    renderPropertiesForm(){
        return (
            <IonModal isOpen={this.state.tab === PROPERTIES_FORM_PAGE} onDidDismiss={this.handleClosePropertyModal.bind(this)}>
                <IonHeader>
                    <IonToolbar>
                        <IonTitle>Property Form</IonTitle>
                        <IonButtons slot="end">
                            <IonButton
                                onClick={this.handleClosePropertyModal.bind(this)}
                            >
                                Close
                            </IonButton>
                        </IonButtons>
                    </IonToolbar>
                </IonHeader>
            <IonContent className="ion-padding">
                <PropertyForm
                    showTable={false}
                    property={this.props.properties[this.state.bulkUtilitiesTabPropertyId] ? this.props.properties[this.state.bulkUtilitiesTabPropertyId] : null}
                />
            </IonContent>
            </IonModal>);
    }

    renderResetUtilitiesForm(){
        return(
            <IonModal isOpen={this.state.tab === RESET_UTILITIES_FORM} onDidDismiss={this.handleCloseResetUtilitiesForm.bind(this)}>
                <IonHeader>
                    <IonToolbar>
                        <IonTitle>Reset Utilities</IonTitle>
                        <IonButtons slot="end">
                            <IonButton
                                onClick={this.handleCloseResetUtilitiesForm.bind(this)}
                            >
                                Close
                            </IonButton>
                        </IonButtons>
                    </IonToolbar>
                </IonHeader>
                <IonContent className="ion-padding">
                    <ResetUtilitiesForm />
                </IonContent>
            </IonModal>
        );
    }

    renderBackButton(){
        return(
            <Row className="d-flex justify-content-start my-2">
                <IonButton className="m-2"
                    style={{ borderColor: colorTheme["primary"]["700"] }}
                    onClick={this.handleBackButton.bind(this)}>
                        <IonIcon icon={arrowBack}></IonIcon>
                        Back
                </IonButton>
            </Row>
        )
    }

    render(){
        return (
            <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonMenuButton />
                    </IonButtons>
                    <IonTitle>Utilities</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent>
                <IonLoading className="custom-loading" isOpen={this.state.showLoading} message="Loading ..." />
                {(this.state.tab == UNIT_UTILITIES_PAGE) && this.renderUtilities(this.state.bulkUtilitiesTabPropertyId, this.state.bulkUtilitiesTabUtilityItem)}

                {(this.state.tab == HOME_PAGE) && this.renderHomePage()}

                {this.renderUtilitiesForm()}

                {this.renderFilters()}

                {(this.state.tab == PROPERTIES_FORM_PAGE) && this.renderPropertiesForm()}

                {(this.state.tab == INVOICES_FORM_PAGE) && this.renderInvoiceForm()}

                {(this.state.tab == RESET_UTILITIES_FORM) && this.renderResetUtilitiesForm()}

                {(this.state.tab === HOME_PAGE ) && (<IonFab className='ion-fab' slot="fixed" vertical="bottom" horizontal="end">
                    <IonFabButton aria-label="Actions">
                        <IonIcon icon={add} />
                    </IonFabButton>
                    <IonFabList side="top">
                        {this.state.userAllPerms.utility && (<>
                        <IonFabButton
                            onClick={() => {
                                this.setState({
                                    tab: UTILITIES_FORM_PAGE,
                                    previousTab: this.state.tab,
                                    unitUtilityIdToEdit: null,
                                    utilityAction: ""
                                });
                                Mixpanel.track("Utilities tab original: Add Utility");
                            }}
                            data-desc="Add Utility"
                        >
                            <IonIcon icon={flashSharp}></IonIcon>
                        </IonFabButton>

                        <IonFabButton
                            onClick={() => {
                                this.setState({
                                    tab: UNIT_UTILITIES_PAGE,
                                    previousTab: this.state.tab,
                                    unitUtilityIdToEdit: null,
                                    utilityAction: ""
                                });
                                Mixpanel.track("Utilities tab original: bulk upload utilities");
                            }}
                            data-desc="Add Multiple Readings"
                        >
                            <IonIcon icon={flashSharp}></IonIcon>
                        </IonFabButton>

                        <IonFabButton
                            onClick={() => {
                                this.setState({
                                    tab: RESET_UTILITIES_FORM,
                                    previousTab: this.state.tab,
                                    unitUtilityIdToEdit: null,
                                    utilityAction: ""
                                });
                                Mixpanel.track("Utilities tab original: Reset Utilities");
                            }}
                            data-desc="Reset Utilities"
                        >
                            <IonIcon icon={flashSharp}></IonIcon>
                        </IonFabButton>
                        </>)}
                    </IonFabList>
                </IonFab>)}
            </IonContent>
          </IonPage>
        );
    }
}

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(Utilities));